import {Link} from 'react-router-dom';
import { useParams } from "react-router-dom";
import React,{ useState,useEffect } from 'react';
import api5 from './api5';
import { FaEnvelopeOpen } from 'react-icons/fa';
function NewsletterSuccess(){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const {order_id} = useParams();
    const [Message,setMessage]=useState('');

    useEffect(()=>{
        const fetchData = async () => {
            try {
                const response = await api5.get(baseUrl+'/verify-subscription/'+order_id);
                setMessage(response.data.message);
            } catch (error) {
                //console.error("Error fetching store status:", error);
            }
        };
    
        fetchData();
    },[]);

    return (
        <section className="container mtopcon normal-mt-sctn">
            <div className="row">
                <div className="col-12 col-lg-6 reglogincon" max-width='100px'>
                    <div className="border-0">
                        <div className="card-body mb-0">                        
                                <div className="row text-center">
                                    <div className="col-md-12 mb-4">
                                        <button className="btn btn-outline-success border-0"><FaEnvelopeOpen width='100px' height='100px' /></button>
                                    </div>
                                    <div className="col-12">
                                        <h3><b>Newsletter subscription</b></h3>
                                        <p>{Message}</p>
                                    </div>
                                </div>
                        </div>
                    </div>

                    <hr/>
                    <div className="row  mt-4 w-90">      
                        <div className='col-6'><Link to="https://kadhr.com/"><button className="btn btn-info text-white h40 w-100">Home</button></Link></div>    
                        <div className='col-6'><Link to="/customer/dashboard"><button className="btn btn-warning h40 w-100">Account</button></Link></div>   
                    </div>

                </div>
            </div>
        </section>
    )
}

export default NewsletterSuccess;